const upgradePersonal = {
  bannerTitle: 'HitPaw en ligne ultime',
  introduct:
    "Bénéficiez plus de 35 fonctionnalités réservées aux membres dans la boîte à outils, notamment l'améliorateur, le suppresseur, le traducteur IA, l'enregistreur d'écran et bien plus encore, le tout à un prix abordable.",
  Upgrade: 'Mettre à niveau',
  Tools: 'Outils',
  MyProjects: 'Mes projets',
  MyAccount: 'Mon compte',
  Subscription: 'Abonnement',
  LogOut: 'Se déconnecter',
  PopularTools: 'Outils populaires',
  Enhance: 'Améliorer',
  Remove: 'Enlever',
  Animate: 'Animer',
  Extract: 'Extraire',
  SaveThreeDays:
    'Les projets sont stockés pendant 3 jours, veuillez les télécharger après traitement.',
  All: 'Tout',
  Video: 'Vidéo',
  Image: 'Image',
  Audio: 'Audio',
  minutesAgo: 'il y a quelques minutes',
  hoursAgo: 'il y a des heures',
  daysAgo: 'il y a quelques jours',
  Modified: 'Modifié',
  Order: 'En ordre',
  EarliestToLatest: 'Du plus ancien au plus récent',
  LatestToEarliest: 'Du plus récent au plus ancien',
  NoProject: 'Pas encore de projet. Démarrage rapide avec',
  OnlineTools: 'Outils en ligne',
  AIVideoEnhancer: 'IA Améliorateur Vidéo ',
  Enhancer4K: "Un clic pour améliorer les vidéos par IA jusqu'à 4K en ligne",
  AIPhotoEnhancer: 'IA Améliorateur Photo',
  AIEnhancerImage:
    "L'IA améliore les images sans perte jusqu'à 8 fois en ligne",
  View: 'Voir',
  Download: 'Télécharger',
  MultipleSelect: 'Multi-sélection  ',
  Delete: 'Supprimer',
  SubscriptionHistory: 'Historique des abonnements',
  NoValidSubscription: 'Aucun abonnement valide.',
  veContent: "Un clic pour améliorer les vidéos par IA jusqu'à 4K en ligne",
  peContent: "L'IA améliore les images sans perte jusqu'à 8 fois en ligne",
  rmvContent: 'Supprimer le filigrane de la vidéo',
  rmttContent: "Supprimer les filigranes vidéo TikTok en un clin d'œil",
  dynamicContent: 'Animez votre photo en ligne',
  rmbgContent: "Supprimer l'arrière-plan de l'image",
  youMayNeed: 'Tu pourrais avoir besoin de',
  new: 'Nouveau',
  loginYourAccount: 'Connectez-vous à votre compte HitPaw',
  signUpYourAccount: 'Inscrivez-vous à votre compte HitPaw',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
